import { differenceInCalendarDays } from "date-fns";

const pluralize = (count: number) => (count === 1 ? "day" : "days");

type DueDateTooltipStatus = "due" | "overdue";

// The status comes from the caller's authoritative due-date calculation. The
// day count is descriptive only, because a viewer's local timezone can put it
// on a different calendar day around the exact Stripe deadline.
export const getDueDateTooltip = (
  status: DueDateTooltipStatus,
  dueDate?: Date | string
): string => {
  if (!dueDate) return status === "overdue" ? "Overdue" : "Due date";

  const due = new Date(dueDate);
  if (Number.isNaN(due.getTime())) {
    return status === "overdue" ? "Overdue" : "Due date";
  }

  const today = new Date();

  if (status === "overdue") {
    const days = differenceInCalendarDays(today, due);
    return days >= 1 ? `Overdue (${days} ${pluralize(days)})` : "Overdue";
  }

  const days = differenceInCalendarDays(due, today);
  if (days === 0) return "Due date (today)";
  return days > 0 ? `Due date (in ${days} ${pluralize(days)})` : "Due date";
};
